if (!customElements.get("sub-widget")) {
  customElements.define(
    "sub-widget",
    class SubWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.handlePlanClick = this.handlePlanClick.bind(this);
        this.handlePlanKeydown = this.handlePlanKeydown.bind(this);

        this.sellingPlanInput = this.querySelector("input[type='hidden']");
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");

        this.addEventListeners();
        this.setInitialPlan();
      }

      setInitialPlan() {
        const initialPlanSelected = this.querySelector('.wt-subscription-widget__plans--selected');
        if (initialPlanSelected) {
          this.handlePlanClick(initialPlanSelected);
        }
      }

      reinit() {
        this.sellingPlanInput = this.querySelector("input[type='hidden']");
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
          plan.addEventListener("keydown", (e) => this.handlePlanKeydown(e, plan));
        });

        this.setInitialPlan();
      }

      addEventListeners() {
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
          plan.addEventListener("keydown", (e) => this.handlePlanKeydown(e, plan));
        });

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const wrapper = this.closest('[data-section-id]');
          const sectionId = wrapper?.dataset?.sectionId;
          const originalSectionId = wrapper?.dataset?.originalSectionId;
          if (sectionId && e.data.sectionId !== sectionId && e.data.sectionId !== originalSectionId) return;

          const parsedHTML = e.data.html.querySelector(".wt-subscription-widget__container");
          if (!parsedHTML) return;

          const currentContainer = this.querySelector('.wt-subscription-widget__container');
          if (!currentContainer) return;

          currentContainer.innerHTML = parsedHTML.innerHTML;
          this.reinit();

          if (originalSectionId) {
            const hiddenInput = this.querySelector('input[name="selling_plan"]');
            if (hiddenInput) hiddenInput.setAttribute('form', `product-form-${sectionId}`);
          }
        });
      }

      handlePlanKeydown(event, plan) {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          this.handlePlanClick(plan);
        }
      }

      handlePlanClick(plan) {
        this.allPlans.forEach((item) => {
          item.classList.remove("wt-subscription-widget__plans--selected");
          if (item.getAttribute('role') === 'radio') {
            item.setAttribute('aria-checked', 'false');
          }
        });
        plan.classList.add("wt-subscription-widget__plans--selected");
        if (plan.getAttribute('role') === 'radio') {
          plan.setAttribute('aria-checked', 'true');
        }

        const selectedPlanValue = plan.dataset.sellingPlanId;
        if (selectedPlanValue) {
          this.sellingPlanInput.value = selectedPlanValue;
        } else {
          this.sellingPlanInput.value = "";
        }

        const priceData = {
          price: plan.dataset.priceFormatted,
          compareAtPrice: plan.dataset.compareAtPriceFormatted,
          priceRaw: Number(plan.dataset.priceRaw),
          compareAtPriceRaw: Number(plan.dataset.compareAtPriceRaw),
        };
        this.updatePriceBlock(priceData);
        this.updateStickyPriceBlock(priceData);

        this.updateURLParamsIfEnabled(selectedPlanValue);
      }

      updatePriceBlock({ price, compareAtPrice, priceRaw, compareAtPriceRaw }) {
        const sectionId = this.closest('[data-section-id]')?.dataset?.sectionId;
        if (!sectionId) return;

        const priceBlock = document.getElementById(`price-${sectionId}`);
        if (!priceBlock) return;

        const priceContainer = priceBlock.querySelector('.price');
        if (!priceContainer) return;

        const isOnSale = compareAtPriceRaw > priceRaw;

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        const regularPriceEl = priceContainer.querySelector('.price__regular .wt-product__price__final');
        if (regularPriceEl) regularPriceEl.innerHTML = price;

        const salePriceEl = priceContainer.querySelector('.price__sale .wt-product__price__final');
        if (salePriceEl) salePriceEl.innerHTML = price;

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.classList.toggle('visible', isOnSale);
          saleDiv.classList.remove('visible-main-product');
        }

        const compareEl = priceContainer.querySelector('.wt-product__price__compare');
        if (compareEl) {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        }

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale) {
          const percent = Math.round((compareAtPriceRaw - priceRaw) / compareAtPriceRaw * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      updateStickyPriceBlock({ price, compareAtPrice, priceRaw, compareAtPriceRaw }) {
        const sectionId = this.closest('[data-section-id]')?.dataset?.sectionId;
        if (!sectionId) return;

        const stickyPriceBlock = document.getElementById(`sticky-price-${sectionId}`);
        if (!stickyPriceBlock) return;

        const priceContainer = stickyPriceBlock.querySelector('.price');
        if (!priceContainer) return;

        const isOnSale = compareAtPriceRaw > priceRaw;

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        const regularPriceEl = priceContainer.querySelector('.price__regular .wt-product__price__final');
        if (regularPriceEl) regularPriceEl.innerHTML = price;

        const salePriceEl = priceContainer.querySelector('.price__sale .wt-product__price__final');
        if (salePriceEl) salePriceEl.innerHTML = price;

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.classList.toggle('visible', isOnSale);
          saleDiv.classList.remove('visible-main-product');
        }

        const compareEl = priceContainer.querySelector('.wt-product__price__compare');
        if (compareEl) {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        }

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale) {
          const percent = Math.round((compareAtPriceRaw - priceRaw) / compareAtPriceRaw * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      updateURLParamsIfEnabled(planId) {
        const wrapper = this.closest('[data-update-url-on-plan-change]');
        if (wrapper?.dataset.updateUrlOnPlanChange === 'false') return;

        const urlParams = new URLSearchParams(window.location.search);
        if (planId) {
          urlParams.set("selling_plan", planId);
        } else {
          urlParams.delete("selling_plan");
        }
        window.history.pushState({}, "", `${window.location.pathname}?${urlParams.toString()}`);
      }

      disconnectedCallback() {
        if (typeof this.unsubscribeVariantChange === 'function') {
          this.unsubscribeVariantChange();
        }
      }
    }
  );
}
